import { Component, OnInit } from '@angular/core';
import { RootDataMapping, ValueDataMapping, PropertyType } from '@ct-software/ct-ui-core';

import channelDictionary from './dashboard-channels.json';

@Component({
    selector: 'dashboard-channels',
    templateUrl: './dashboard-channels.component.html',
    standalone: false
})
export class DashboardChannelsComponent implements OnInit {
  public mapping: RootDataMapping;

  public ngOnInit(): void {
    const items = channelDictionary;

    const variableMapping = new RootDataMapping(items);
    new ValueDataMapping(variableMapping, "ID", ["[]", "name"], { type: PropertyType.Text, width: 250 });
    new ValueDataMapping(variableMapping, "Is ACTive", ["[]", "isACTive"], { type: PropertyType.Text, width: 80 });
    new ValueDataMapping(variableMapping, "Description", ["[]", "description"], { type: PropertyType.Text, width: 750 });
    variableMapping.readonly$.next(true);
    this.mapping = variableMapping;
  }
}
